import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { ParcelTypeEnum } from 'src/app/domain/registration/enums/parcel-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { CustomerPlanItemsSelectComponent } from '../../customers/customer-plan-items/customer-plan-items-select.component';

export const RELATIVE_URL = 'bills';

export const COLUMNS_TO_SHOW_WEB = [
  // 'code',
  // 'origin',
  'type',
  'parcel',
  // 'ourNumber',
  // 'document',
  'emissionDate',
  'dueDate',
  // 'delayDays',
  'value',
  'fees',
  'fine',
  // 'fees',
  'discountValue',
  'total',
  'actions',
];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'code',
    display: 'COD.',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },

  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'origin',
    display: 'ORIGEM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },

  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'TIPO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'parcel',
    display: 'PARCELA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'ourNumber',
    display: 'NOSSO NÚMERO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'document',
    display: 'DOCUMENTO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'emissionDate',
    display: 'DATA DE EMISSÃO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'dueDate',
    display: 'DATA DE VENCIMENTO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'delayDays',
    display: 'DIAS DE ATRASO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_CURRENCY,
    link_show: true,
    property: 'value',
    display: 'VALOR',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fees',
    display: 'JUROS (%)',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'fine',
    display: 'MULTA (%)',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_CURRENCY,
    link_show: true,
    property: 'discountValue',
    display: 'DESCONTO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_CURRENCY,
    link_show: true,
    property: 'total',
    display: 'TOTAL',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  // code
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'CÓDIGO',
    name: 'code',
    placeholder: 'Insira o código',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // origin
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'ORIGEM',
    name: 'origin',
  },
  // type
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    options: Object.values(ParcelTypeEnum),
    placeholder: 'Insira o tipo',
  },
  // system
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'PLANO',
    name: 'plan',
    componentData: {
      params: { plans: [] },
    },
    value: 'code',
    defaultValue: ' ',
    dialogConfig: {
      minWidth: '200px',
      maxWidth: '1800px',
      minHeight: '200px',
      maxHeight: '900px',
      width: 'auto',
      height: 'auto',
    },
    component: CustomerPlanItemsSelectComponent,
  },
  // parcel
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'Nº PARCELAS',
    name: 'parcel',
    placeholder: 'Insira a parcela',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // due date
  {
    type: TypeComponentFieldEnum.INPUT_DATE,
    label: '1º VENCIMENTO',
    name: 'firstDueDate',
    placeholder: 'Insira o primeiro vencimento',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // mensalidade
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'MENSALIDADE',
    name: 'monthlyValue',
    placeholder: 'Insira a mensalidade',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // desconto
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'DESCONTO',
    name: 'discountValue',
    placeholder: 'Insira o desconto',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // total
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'TOTAL PERÍODO',
    name: 'totalPaidValue',
    placeholder: 'Insira o total período',
    validation: [Validators.required, Validators.minLength(4)],
  },

  // TAXA
  // valor da taxa
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'VALOR',
    name: 'adhesionFee',
    default: 0,
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // vencimento da taxa
  {
    type: TypeComponentFieldEnum.INPUT_DATE,
    label: 'VENCIMENTO',
    name: 'adhesionFeeDueDate',
    placeholder: 'Insira o vencimento',
    validation: [Validators.required, Validators.minLength(4)],
  },

  // porcentagem juros por dia da taxa
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'JUROS DIA',
    default: 0,
    name: 'fees',
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // multa unica da taxa
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'MULTA ÚNICA',
    name: 'fine',
    default: 0,
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },


  // IMPLANTAÇÃO
  // valor implantação
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'VALOR',
    name: 'deploymentValue',
    default: 0,
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // vencimento da implantação
  {
    type: TypeComponentFieldEnum.INPUT_DATE,
    label: 'VENCIMENTO',
    name: 'deploymentDueDate',
    placeholder: 'Insira o vencimento',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // porcentagem juros por dia da implantação
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'JUROS DIA',
    name: 'implementationInterestPercentPerDay',
    default: 0,
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // multa unica da implantação
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'MULTA ÚNICA',
    name: 'implementationSingleFine',
    default: 0,
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },

  // DIAS CORRIDOS
  // valor dias corridos
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'VALOR',
    name: 'daysCountValue',
    default: 0,
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // vencimento da implantação
  {
    type: TypeComponentFieldEnum.INPUT_DATE,
    label: 'VENCIMENTO',
    name: 'daysCountDueDate',
    placeholder: 'Insira o vencimento',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // porcentagem juros por dia da implantação
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'JUROS DIA',
    name: 'daysCountInterestPercentPerDay',
    default: 0,
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },
  // multa unica da implantação
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'MULTA ÚNICA',
    name: 'daysCountSingleFine',
    default: 0,
    placeholder: 'Insira o valor',
    validation: [Validators.required, Validators.minLength(4)],
  },

  // gerar boleto
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'GERAR BOLETO',
    name: 'generateBill',
    placeholder: 'Gerar boleto',
    default: true
  },
  // enviar email
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'ENVIAR EMAIL',
    name: 'sendEmail',
    placeholder: 'Enviar email'
  },
  // taxa + primeira mensalidade
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'TAXA + PRIMEIRA MENSALIDADE',
    name: 'feeFirstMonthly',
    placeholder: 'Insira a taxa + primeira mensalidade',
  },
  // anual pago
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'ANUAL PAGO',
    name: 'annualPaid',
    placeholder: 'Anual pago'
  },
];
